"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CFFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_43)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_43`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.19995 0H34.8V24H-1.19995V0Z",
					fill: "#D21034"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.19995 12H13.6422V17.986H-1.19995V12ZM19.8878 12H34.7299V17.986H19.8878V12Z",
					fill: "#3A9927"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.19995 0V5.98597H13.6422V0H19.8878V5.98597H34.8V0H-1.19995Z",
					fill: "#003082"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.8878 5.98596H34.7299V11.9719H19.8878V5.98596ZM-1.19995 5.98596H13.6422V11.9719H-1.19995V5.98596Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.8878 24H13.6422V17.9649H-1.19995V24H34.8V17.9649H19.8878V24ZM6.21759 0.603516L6.8211 2.44211H8.75093L7.18601 3.57895L7.78952 5.41755L6.21759 4.28071L4.65268 5.41755L5.24917 3.57895L3.68426 2.44211H5.6211L6.21759 0.603516Z",
					fill: "#FFCE00"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_43`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CFFlag };
